
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_8mzwp_3",
  "disabled": "awsui_disabled_16mm3_8mzwp_18",
  "expandable-header": "awsui_expandable-header_16mm3_8mzwp_21",
  "rolled-down": "awsui_rolled-down_16mm3_8mzwp_28",
  "highlighted": "awsui_highlighted_16mm3_8mzwp_31",
  "variant-navigation": "awsui_variant-navigation_16mm3_8mzwp_40",
  "category": "awsui_category_16mm3_8mzwp_52",
  "expandable": "awsui_expandable_16mm3_8mzwp_21",
  "expand-icon": "awsui_expand-icon_16mm3_8mzwp_73",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_8mzwp_80",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_8mzwp_83",
  "items-list-container": "awsui_items-list-container_16mm3_8mzwp_97"
};
  